// TODO: reduce complexity
import { getMaxHistoryByGame } from '@lobby/store/epics/socket/functions';
import { definitionsSelector } from '@lobby/store/selectors/config';
import { userSelector } from '@lobby/store/selectors/user';
import { isBJSalonPrive, isBlackjack } from '@lobby/utils/functions';
import { of } from 'rxjs';

import { addRootToPath, parseImageUrl } from '@ezugi/hooks/helpers/imageUrlParser';

import { app } from '../../app';
import { socket } from '../../socket';
import { tables } from '../../tables';
import { user } from '../../user';

const countAvailableSeats = (AvailableSeats = []) => AvailableSeats
  .filter((seat) => seat.SeatId !== 'd' && seat.Taken).length;

export const handleInitialData = (socketMessage, state) => {
  const { games, UpdatedBalance, WidgetData } = socketMessage;
  const definitions = definitionsSelector(state);
  const userData = userSelector(state);

  const nextTables = games.reduce((acc, table) => {
    const {
      GameTypeID,
      PlayersNumber,
      TableID,
      AvailableSeats: AvailableGameSeats,
    } = table;

    let playersCount;
    let isOccupied;
    let history = [];

    if (isBlackjack(GameTypeID) && AvailableGameSeats) {
      playersCount = countAvailableSeats(AvailableGameSeats);
    } else {
      playersCount = PlayersNumber || 0;
    }

    const tableWidget = WidgetData.find(({ TableId }) => TableId === TableID);

    if (tableWidget) {
      const { History, AvailableSeats } = tableWidget;

      if (History) {
        history = History;
      }

      if (table.TableID !== table.MetaTableID && table.MetaTableID) {
        const metaTableWidget = WidgetData.find(
          ({ TableId }) => +TableId === +table.MetaTableID
        );

        /**
         * Use history from meta table only if available (operators can have a child table assigned but not the child's meta,
         * therefore engine is not sending data about meta table)
         */
        if (metaTableWidget?.History) {
          history = metaTableWidget?.History;
        }
      }

      history = history?.slice(-getMaxHistoryByGame(GameTypeID));

      if (AvailableSeats) {
        history = AvailableSeats;
        playersCount = countAvailableSeats(AvailableSeats);
      }

      if (isBJSalonPrive(GameTypeID)) {
        const { TableOccupied, ClientIds } = tableWidget;
        const { uid, operatorId } = userSelector(state);

        isOccupied = TableOccupied
          && !ClientIds?.includes(`${operatorId}|${uid}|${TableID}`);
      }
    }

    // TODO: responsive-image - remove oldDynamicImage after BE integration
    const oldDynamicImage = `${definitions.DEALER_IMAGES + table.MetaTableID}.jpg?v=${Date.now()}`;

    const useDynamic = Boolean(+table.UseDynamicTableImg);
    const dynamicImage = useDynamic
      ? parseImageUrl(table.DynamicTableImage || oldDynamicImage)
      : undefined;

    const openImage = parseImageUrl(addRootToPath(definitions.OPERATOR_ASSETS, table.OpenTableImg));
    const closeImage = parseImageUrl(addRootToPath(definitions.OPERATOR_ASSETS, table.CloseTableImg));

    return {
      ...acc,
      [+TableID]: {
        playersCount,
        isOccupied,
        history,
        openHour: table.OpenHour,
        closeHour: table.CloseHour,
        active: Boolean(+table.IsActive),
        isNew: Boolean(+table.NewRibbon),
        gameId: +table.GameTypeID,
        tableId: +table.TableID,
        metaTableId: table.MetaTableID ? +table.MetaTableID : undefined,
        title: table.TableName,
        closeImage,
        openImage,
        dynamicImage,
        useDynamic,
        language: table.Language ? (table.Language).toLowerCase() : undefined,
        favorite: userData.favorite.includes(+table.TableID),
        limits: table.limits.reduce(
          (_acc, limit) => ({
            ..._acc,
            [limit.LimitID]: {
              ...limit,
              id: limit.LimitID,
            },
          }),
          {}
        ),
      },
    };
  }, {});

  return of(
    tables.set(nextTables),
    user.update({ balance: UpdatedBalance }),
    socket.success(),
    app.start()
  );
};
